<div class="page-header">
  <app-prev-next-button (click)="toSetup()" direction="left" label="setup"></app-prev-next-button>
  <h1>Definir Posições Escaninho</h1>
  <button mat-raised-button class="primary" (click)="toFinish()">
    Ir para próximo passo
  </button>
</div>

<div class="page-content">
  <div class="left-side">
    <app-pigeonhole-positions-list
      [positions]="selectedPositions"
      (onRemove)="removeFromList($event)"
      (save)="save()"
      (cancel)="cancel()"
    >
    </app-pigeonhole-positions-list>
  </div>
  <div class="right-side">
    <app-side-color-card color="primary-1">
      <app-setup-pigeonhole-map
                            (positionClicked)="positionSelected($event)"
                            [selectedPositionIds]="selectedPositionIds"
                            [map]="map"
                            content #mapComponent>
      </app-setup-pigeonhole-map>
    </app-side-color-card>
  </div>
</div>
